/**
 login-view
 Created by RuSsCiTy on 07.05.2018
 **/

import Backbone from "backbone";

const template = require("./template.pug");

export default Backbone.View.extend({
  initialize(container) {
    this.render(container);
    this.initElements();
    this.hide();
  },

  render(container) {
    this.$el.html(template);
    container.html(this.$el);
  },

  initElements() {
    this.$mainView = $(this.$(".loading-view"));
  },

  show() {
    this.$mainView.css("pointer-events", "auto");
    this.$mainView.css("opacity", "1");
  },

  hide() {
    this.$mainView.css("pointer-events", "none");
    this.$mainView.css("opacity", "0");
  }
});



// WEBPACK FOOTER //
// ./src-cookie-manager/views/loading/loading-view.js